import { render } from "./AdminLevelincome.vue?vue&type=template&id=05b62243&scoped=true"
import script from "./AdminLevelincome.vue?vue&type=script&lang=js"
export * from "./AdminLevelincome.vue?vue&type=script&lang=js"

import "./AdminLevelincome.vue?vue&type=style&index=0&id=05b62243&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b62243"]])

export default __exports__